import React from 'react';
import { NavLink } from 'react-router-dom';
import StudentsCounter from '../StudentsCounter';

const WhoWeAre = () =>{
    return (
        <>
        <div className='cadAbout cadAboutHome'>
            <div className='container'>
                <div className='cadAboutTitleImg'>
                    <img 
                    src="assets/angle-down.webp"
                    alt="angle-down" />
                </div>
                <h6>ABOUT</h6>
                <h2>WHO WE ARE?</h2>
                <StudentsCounter />
                <p>We at CAD & RENDER are a professional and experienced team of 3D artists who offer you the possibility of growing your business exponentially through the creation of 3D CAD Models, Rendered Photorealistic Images, Rendered Realistic Animation Videos and 3D Model Prints of your jewelry products enabling you to get a boost in your sales through the quality and accuracy of our work.</p>
                <div className="cadAboutBtn">
                    <NavLink to="/about-us">READ MORE</NavLink>
                </div>
            </div>
        </div>
        </>
    );
}

export default WhoWeAre;